import React, { useRef } from 'react';
import QRCode from 'react-qr-code';

const QRCodeGenerator = () => {
  const qrRef = useRef();
  const siteUrl = 'https://for-anything-parking.onrender.com/';

  const downloadQRCode = () => {
    const svg = qrRef.current;
    const svgData = new XMLSerializer().serializeToString(svg);
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();

    // High resolution for printing (300 DPI)
    canvas.width = 3000;
    canvas.height = 3000;

    img.onload = () => {
      ctx.fillStyle = 'white';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

      const pngFile = canvas.toDataURL('image/png');
      const downloadLink = document.createElement('a');
      downloadLink.download = 'parking-qr-code.png';
      downloadLink.href = pngFile;
      downloadLink.click();
    };

    img.src = 'data:image/svg+xml;base64,' + btoa(svgData);
  };

  const downloadSVG = () => {
    const svg = qrRef.current;
    const svgData = new XMLSerializer().serializeToString(svg);
    const svgBlob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
    const svgUrl = URL.createObjectURL(svgBlob);
    const downloadLink = document.createElement('a');
    downloadLink.href = svgUrl;
    downloadLink.download = 'parking-qr-code.svg';
    downloadLink.click();
  };

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#f8f9fa',
      padding: '40px 20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <div style={{
        maxWidth: '800px',
        width: '100%',
        backgroundColor: 'white',
        borderRadius: '12px',
        boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
        padding: '40px'
      }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <h1 style={{ fontSize: '32px', fontWeight: '700', color: '#111827', marginBottom: '8px', margin: '0 0 8px 0' }}>
            Parking QR Code Generator
          </h1>
          <p style={{ color: '#6b7280', margin: 0 }}>
            Download high-quality QR codes for printing
          </p>
        </div>

        {/* QR Code Display */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          marginBottom: '32px',
          padding: '40px',
          backgroundColor: '#f9fafb',
          borderRadius: '8px'
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '30px',
            borderRadius: '8px',
            boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
          }}>
            <QRCode
              ref={qrRef}
              value={siteUrl}
              size={300}
              level="H"
              style={{ height: "auto", maxWidth: "100%", width: "100%" }}
            />
          </div>
        </div>

        {/* URL Display */}
        <div style={{
          backgroundColor: '#eff6ff',
          border: '1px solid #bfdbfe',
          borderRadius: '8px',
          padding: '16px',
          marginBottom: '32px'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <svg style={{ width: '20px', height: '20px', color: '#1e40af', marginRight: '8px' }} fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M12.586 4.586a2 2 0 112.828 2.828l-3 3a2 2 0 01-2.828 0 1 1 0 00-1.414 1.414 4 4 0 005.656 0l3-3a4 4 0 00-5.656-5.656l-1.5 1.5a1 1 0 101.414 1.414l1.5-1.5zm-5 5a2 2 0 012.828 0 1 1 0 101.414-1.414 4 4 0 00-5.656 0l-3 3a4 4 0 105.656 5.656l1.5-1.5a1 1 0 10-1.414-1.414l-1.5 1.5a2 2 0 11-2.828-2.828l3-3z" clipRule="evenodd" />
            </svg>
            <span style={{
              fontFamily: 'monospace',
              fontSize: '14px',
              color: '#1e40af',
              wordBreak: 'break-all'
            }}>
              {siteUrl}
            </span>
          </div>
        </div>

        {/* Download Buttons */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '24px' }}>
          <button
            onClick={downloadSVG}
            style={{
              padding: '16px 24px',
              borderRadius: '8px',
              fontWeight: '600',
              fontSize: '16px',
              border: '2px solid #1e3a5f',
              cursor: 'pointer',
              background: 'white',
              color: '#1e3a5f',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.background = '#f9fafb';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = 'white';
            }}
          >
            📄 Download SVG
          </button>

          <button
            onClick={downloadQRCode}
            style={{
              padding: '16px 24px',
              borderRadius: '8px',
              fontWeight: '600',
              fontSize: '16px',
              border: 'none',
              cursor: 'pointer',
              background: '#1e3a5f',
              color: 'white',
              transition: 'all 0.2s ease',
              boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
            }}
            onMouseEnter={(e) => {
              e.target.style.background = '#2d5a7b';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = '#1e3a5f';
            }}
          >
            🖼️ Download PNG (High Res)
          </button>
        </div>

        {/* Instructions */}
        <div style={{
          backgroundColor: '#f9fafb',
          borderRadius: '8px',
          padding: '20px'
        }}>
          <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#111827', marginBottom: '12px', margin: '0 0 12px 0' }}>
            Printing Instructions:
          </h3>
          <ul style={{
            margin: 0,
            paddingLeft: '20px',
            color: '#6b7280',
            fontSize: '14px',
            lineHeight: '1.8'
          }}>
            <li><strong>SVG Format:</strong> Best for professional printing (scales to any size)</li>
            <li><strong>PNG Format:</strong> 3000x3000px at 300 DPI for high quality prints</li>
            <li><strong>Minimum Size:</strong> Print at least 2" x 2" for easy scanning</li>
            <li><strong>Test First:</strong> Print a test copy and scan with your phone</li>
            <li><strong>Placement:</strong> Keep QR code flat and at eye level when possible</li>
          </ul>
        </div>

        {/* Spot-Specific QR Codes */}
        <div style={{
          marginTop: '32px',
          padding: '20px',
          backgroundColor: '#fef3c7',
          border: '1px solid #fde047',
          borderRadius: '8px'
        }}>
          <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#78350f', marginBottom: '8px', margin: '0 0 8px 0' }}>
            💡 Want Spot-Specific QR Codes?
          </h3>
          <p style={{ fontSize: '14px', color: '#78350f', margin: '0 0 8px 0' }}>
            You can create QR codes that pre-fill a specific parking spot:
          </p>
          <ul style={{
            margin: 0,
            paddingLeft: '20px',
            color: '#78350f',
            fontSize: '14px'
          }}>
            <li>Spot A: <code>https://for-anything-parking.onrender.com/spot/A</code></li>
            <li>Spot B: <code>https://for-anything-parking.onrender.com/spot/B</code></li>
            <li>Spot 1: <code>https://for-anything-parking.onrender.com/spot/1</code></li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default QRCodeGenerator;
